module.exports = __webpack_public_path__ + "img/iconDeviceEnable.a7d465dc.svg";